import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import FeedbackList from '@components/feedbackList';
import FeedbackFilter from '@components/feedbackFilter';
import type { FeedbackFilterOption, FeedbackFilterParams } from '@components/feedbackFilter';
import type { FeedbackProductCategory, FeedbackProductItem, FetchProductsParams } from '@components/feedbackProductPicker';
import type { FeedbackProblemCategory, FeedbackProblemItem } from '@components/feedbackProblemPicker';

interface FeedbackListH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    setPost?: any;
    feedbackList?: any[];
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    filterParams?: FeedbackFilterParams;
    searchInputValue?: string;
    solveStateList?: FeedbackFilterOption[];
    problemList?: FeedbackFilterOption[];
    problemCategories?: FeedbackProblemCategory[];
    productList?: FeedbackFilterOption[];
    productCategories?: FeedbackProductCategory[];
    daysList?: FeedbackFilterOption[];
    onSearchChange?: (value: string) => void;
    onSearchConfirm?: () => void;
    onFilterChange?: (key: keyof FeedbackFilterParams, value: string) => void;
    onAdvancedFilterConfirm?: (values: Pick<FeedbackFilterParams, 'solveState' | 'daysValue'>) => void;
    onProblemSelect?: (problem: FeedbackProblemItem | null) => void;
    onProductSelect?: (product: FeedbackProductItem | null) => void;
    fetchProducts?: (params: FetchProductsParams) => Promise<FeedbackProductItem[]>;
    searchKeyword?: string;
    totalCount?: number;
}

interface FeedbackListH5State {
    loading: boolean;
    error: any
    pageLoaded: any
}

@inject('app', 'site', 'user', 'thread', 'setPost')
@observer
class FeedbackListH5Page extends BasePage<FeedbackListH5PageProps, FeedbackListH5State> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
    };

    componentDidMount() {
        super.componentDidMount();
    }

    handleCreateFeedback = () => {
        const { problemList = [], setPost, history } = this.props;
        const selectedProblem = problemList[0];

        if (setPost?.clearPostData) {
            setPost.clearPostData();
        }

        if (setPost?.setPostData) {
            setPost.setPostData({
                type: 2,
                source: 'H5',
                ...(selectedProblem ? {
                    problemId: String(selectedProblem.value ?? selectedProblem.id ?? ''),
                    problemName: selectedProblem.name || '',
                    problemSolvedCount: Number((selectedProblem as any).solvedCount ?? 0) || 0,
                } : {}),
            });
        }

        history.push('/setFeedbackPost');
    }

    renderFeedbackList = () => {
        const { feedbackList, loading, hasMore, onLoadMore, searchKeyword } = this.props;
        return (
            <div style={{ marginBottom: 16 }}>
                <FeedbackList
                    data={feedbackList}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore}
                    searchKeyword={searchKeyword}
                    namespace="feedbackList"
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                />
            </div>
        );
    }

    render() {
        const {
            filterParams,
            searchInputValue,
            solveStateList,
            problemList,
            problemCategories,
            productList,
            productCategories,
            daysList,
            onSearchChange,
            onSearchConfirm,
            onFilterChange,
            onAdvancedFilterConfirm,
            onProblemSelect,
            onProductSelect,
            fetchProducts,
        } = this.props;

        return (
            <div className={styles.wrapper}>
                <div className={styles.feedbackContent}>
                    {filterParams && (
                        <FeedbackFilter
                            filterParams={filterParams}
                            searchInputValue={searchInputValue || ''}
                            solveStateList={solveStateList || []}
                            problemList={problemList || []}
                            problemCategories={problemCategories || []}
                            productList={productList || []}
                            productCategories={productCategories || []}
                            daysList={daysList || []}
                            onSearchChange={onSearchChange}
                            onSearchConfirm={onSearchConfirm}
                            onFilterChange={onFilterChange}
                            onAdvancedFilterConfirm={onAdvancedFilterConfirm}
                            onProblemSelect={onProblemSelect}
                            onProductSelect={onProductSelect}
                            fetchProducts={fetchProducts}
                        />
                    )}
                    {this.renderFeedbackList()}
                    <div className={styles.footerFixed}>
                        <div className={styles.myFeedbackEnter} onClick={() =>
                            window.globalEnsureLogin(() => {
                                this.props.history.push(`/myFeedbackList`);
                            })}
                        >
                            <img src={`${BASE_IMG_URL}/feedback/icon7.png`} alt="性别" className={styles.icon}/>
                            <div className={styles.text}>我的反馈</div>
                        </div>
                        <div
                            className={styles.toPost}
                            onClick={() => window.globalEnsureLogin(() => this.handleCreateFeedback())}
                        >
                            我要反馈
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(FeedbackListH5Page);
